
export default {
	
	inserted(el, binding) {
        for ( let toggler of el.querySelectorAll('.toggler') ) {
            toggler.accordionClickHandler = function(e) {
                var target = e.target;
                var element = target.closest('.accordion-element');
                var toggle_to = element.classList.contains('active');
                e.stopPropagation();
                
                if ( el.classList.contains('accordion-like') ) {
                    $container.toggleClass('active');
                } else {
                    for ( let child of el.querySelectorAll('.accordion-element') ) {
                        child.classList.remove('active');
                    }
                    
                    element.classList.toggle('active', !toggle_to);
                }
                
                // Scroll to the clicked element
                let scrollTarget = target.closest('.simplebar-content-wrapper');
                
                setTimeout(() => {
                    if ( scrollTarget ) {
                        scrollTarget.scrollTo({top: target.offsetTop, behavior: 'smooth'});
                    } else {
                        window.scrollToTarget(target);
                    }
                }, 300);
            };
            
            toggler.addEventListener("click", toggler.accordionClickHandler);
        }
	},
    
    unbind(el) {
        for ( let toggler of el.querySelectorAll('.toggler') ) {
            toggler.removeEventListener("click", toggler.accordionClickHandler);
        }
    },
	
};
